// Bootstrap JS
var bootstrap = require("bootstrap");
// import bootstrap from "bootstrap";
import AOS from "aos";
export function getNavigation() {

  /* grid-control*/
  const rootEl = document.getElementById("root");
  const gridControlBtn = document.querySelectorAll(
    ".grid-control button"
  );
  gridControlBtn.forEach(el => el.addEventListener('click', event => {
    // gridControlBtn.classList.remove("active");

    setTimeout(() => {
      AOS.refresh();
      // console.log("AOS REFRESH");
    }, 100);
    let attribute = el.getAttribute("data-grid");
    for (var i = 0, len = gridControlBtn.length; i < len; i++) {
      gridControlBtn[i].classList.remove("active");
      rootEl.classList.remove("grid-4x", "grid-5x", "grid-6x");
      rootEl.classList.add(`grid-${attribute}x`);
      // console.log("click", gridControlBtn[i]);
    }
    console.log("attribute", attribute);
    event.target.classList.add("active");
    // rootEl.classList.add("grid-5x");

  }));
  // Array.from(gridControlBtn).forEach(function (e) {
  //   e.addEventListener('click', changeGrid);
  // });
  // function changeGrid(e) {
  //   let attribute = this.getAttribute("data-grid");
  //   console.log(attribute);
  //   console.log("click", e.classList);
  // };
  // gridControlBtn.addEventListener("click", (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   console.log("click", event.target);
  // });
  /* end grid-control*/
  const navLinks = document.querySelectorAll(
    ".site-header .navbar-nav .nav-item"
  );
  const menuToggle = document.getElementById("navbarCollapse");
  const bsCollapse = new bootstrap.Collapse(menuToggle, { toggle: false });

  /* collapse */
  const body = document.querySelector("body");
  menuToggle.addEventListener("show.bs.collapse", function (e) {
    // console.log("open s");
    body.classList.add("menu-open-quick");
  });

  menuToggle.addEventListener("shown.bs.collapse", function (e) {
    // console.log("open");
    body.classList.add("menu-open");
  });
  menuToggle.addEventListener("hide.bs.collapse", function (e) {
    // console.log("close");
    body.classList.remove("menu-open");
    body.classList.remove("menu-open-quick");
  });

  const navbarCollapseNavTarget = document.querySelector("#navbarCollapseNav");
  document.addEventListener("click", (event) => {
    const withinBoundaries = event
      .composedPath()
      .includes(navbarCollapseNavTarget);
    if (!withinBoundaries && document.body.classList.contains("menu-open")) {
      bsCollapse.toggle();
    }
  });

  document.onkeydown = function (e) {
    e = e || window.event;
    var isEscape = false;
    if ("key" in e) {
      isEscape = e.key === "Escape" || e.key === "Esc";
    } else {
      isEscape = e.keyCode === 27;
    }
    if (isEscape && document.body.classList.contains("menu-open")) {
      bsCollapse.toggle();
    }
  };

  /* scroll position header control */
  const header = document.querySelector(".site-header");

  document.addEventListener("scroll", function () {
    if (window.scrollY > 180) {
      header.classList.add("header_scroll");
    } else {
      header.classList.remove("header_scroll");
    }
  });
}
